import { InputAdornment, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import { colors } from 'theme'
import React, { useState, useCallback } from 'react'
import { SearchContainer, StyledTextField, SearchButton } from './styles'

interface ClearableSearchBarProps {
  onSearch: (value: string) => void
  buttonText: string
  placeholder: string
  initialValue?: string
}

export const ClearableSearchBar: React.FC<ClearableSearchBarProps> = ({
  onSearch,
  buttonText,
  placeholder,
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue)

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }, [])

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      onSearch(value)
    }
  }, [value, onSearch])

  const handleClear = useCallback(() => {
    setValue('')
    onSearch('')
  }, [onSearch])

  const handleButtonClick = useCallback(() => {
    onSearch(value)
  }, [value, onSearch])

  return (
    <SearchContainer>
      <StyledTextField
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onClick={(e) => {
          if (e.target instanceof HTMLInputElement) {
            e.target.select();
          }
        }}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position='end'>
              <IconButton size='small' onClick={handleClear} edge='end' data-testid="clear-button">
                <CloseIcon fontSize='medium' sx={{ color: colors.primary.DEFAULT, marginRight: '8px' }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      {buttonText && (
        <SearchButton
          variant="contained"
          onClick={handleButtonClick}
        >
          {buttonText}
        </SearchButton>
      )}
    </SearchContainer>
  )
}

export default ClearableSearchBar 